(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neills-holiday-sale-status"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('neills-holiday-sale-status')) {
  customElements.define('neills-holiday-sale-status', class extends HTMLElement {
    static state(approved, startsAt, endsAt, now = Date.now()) {
      const iso = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/;
      if (!approved || !iso.test(startsAt) || !iso.test(endsAt)) return 'inactive';
      const start = Date.parse(startsAt);
      const end = Date.parse(endsAt);
      if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return 'inactive';
      if (now < start) return 'upcoming';
      if (now >= end) return 'ended';
      return 'active';
    }
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      document.addEventListener('visibilitychange', () => this.update(), options);
      window.addEventListener('pageshow', () => this.update(), options);
      this.update();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.abort = null;
    }
    update() {
      clearTimeout(this.timer);
      const now = Date.now();
      const state = this.constructor.state(this.dataset.approved === 'true', this.dataset.start, this.dataset.end, now);
      this.dataset.state = state;
      this.querySelector('[data-holiday-heading]').textContent = this.dataset[state + 'Heading'];
      this.querySelector('[data-holiday-copy]').textContent = this.dataset[state + 'Copy'];
      const boundary = state === 'upcoming' ? Date.parse(this.dataset.start) : state === 'active' ? Date.parse(this.dataset.end) : null;
      if (boundary) this.timer = setTimeout(() => this.update(), Math.min(Math.max(boundary - now + 50, 50), 2147483647));
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
